import React from 'react';
import { Users, AlertOctagon, FileText, ShieldCheck } from 'lucide-react';
import { Reveal, SectionEyebrow, SectionTitle, SectionBody, Container } from './Primitives';
import { useLanguage } from '@/context/LanguageContext';
import { SITE } from '@/constants/testIds';

const icons = [Users, AlertOctagon, FileText, ShieldCheck];

const Problem = () => {
  const { t } = useLanguage();
  return (
    <section
      id="problem"
      data-testid={SITE.sectionProblem}
      className="relative py-20 lg:py-32 bg-[#F7F8F5]"
    >
      <Container>
        <div className="max-w-3xl">
          <Reveal>
            <SectionEyebrow>{t.problem.eyebrow}</SectionEyebrow>
          </Reveal>
          <Reveal delay={0.05}>
            <SectionTitle className="mt-4">{t.problem.title}</SectionTitle>
          </Reveal>
          <Reveal delay={0.1}>
            <SectionBody className="mt-6">{t.problem.body}</SectionBody>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {t.problem.cards.map((card, i) => {
            const Icon = icons[i];
            return (
              <Reveal key={card.title} delay={i * 0.06}>
                <article
                  data-testid={SITE.challengeCard}
                  className="h-full bg-white rounded-2xl p-7 border border-[rgba(0,166,81,0.1)] hover:border-[rgba(0,166,81,0.35)] transition-all duration-300 shadow-[0_4px_20px_-4px_rgba(0,0,0,0.05)] hover:shadow-[0_18px_40px_-10px_rgba(0,166,81,0.18)] hover:-translate-y-1 group"
                >
                  <div className="w-12 h-12 rounded-xl bg-[#F7F8F5] flex items-center justify-center group-hover:bg-[#00A651]/10 transition-colors">
                    <Icon size={22} className="text-[#00A651]" />
                  </div>
                  <h3 className="mt-5 font-['Outfit'] text-lg font-semibold text-[#0B0F0C]">
                    {card.title}
                  </h3>
                  <p className="mt-2 text-sm text-[#5C5C5C] leading-relaxed">{card.desc}</p>
                </article>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={0.3}>
          <div className="mt-16 relative">
            <div className="absolute left-0 top-0 bottom-0 w-1 bg-[#00A651] rounded-full" />
            <p className="pl-6 font-['Outfit'] text-xl sm:text-2xl lg:text-3xl font-medium text-[#0B0F0C] leading-snug max-w-3xl">
              {t.problem.closing}
            </p>
          </div>
        </Reveal>
      </Container>
    </section>
  );
};

export default Problem;
